import {call} from 'redux-saga/effects';
import {get} from './api';

export default (flows) => {
  flows.getFlow('get').setActions({
    onFetch: function* () {
      const {data} = yield call(() => get());

      return data;
    },
  });

  return flows.getSagas();
};
